import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './SectionHeading.module.scss';

export default function SectionHeading({
  title,
  subtitle,
  titleClassName,
  subtitleClassName,
  className,
}) {
  return (
    <div className={classNames(styles.root, { [className]: className })}>
      <div
        className={classNames(styles.title, {
          [titleClassName]: titleClassName,
        })}
      >
        {title}
      </div>
      {subtitle && (
        <div
          className={classNames(styles.subtitle, {
            [subtitleClassName]: subtitleClassName,
          })}
        >
          {subtitle}
        </div>
      )}
    </div>
  );
}

SectionHeading.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.string,
  titleClassName: PropTypes.string,
  subtitleClassName: PropTypes.string,
  className: PropTypes.string,
};
